import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Faq = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="span">How are points awarded for each problem?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          Each problem awards an initial 1000 points. Achieving a zone awards 500 points, and achieving a top awards 1000 points. These points are then divided equally among all users who logged progress on that problem. For example, if one user achieves a top and two other users achieve a zone on the same problem, the top will be worth 500 points, and each zone will be worth 250 points.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="span">How is the leaderboard ranked?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          Each person's score is the sum of their top 10 problem scores.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="span">What happens if you log more than 10 problems?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          While only the 10 highest-scoring problems count towards the leaderboard, logging more problems can lower individual problem scores.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="span">Who can help me with other questions?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          Jostein Øygarden<br/>
          <a href="mailto:jostein.oygarden@gmail.com">jostein.oygarden@gmail.com</a>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default Faq;